import { FIXED } from '../constants/constants';

/**
 * Returns discount amount for the current tariff.
 *
 * @param {{cost}} cost
 * @param {{discount, unit}} period
 * @param {{number}} currencyRate
 * @return {number}
 */
export default (cost, period, currencyRate) => {
    const unit = period?.unit?.toLowerCase() ?? period?.interval_discount_unit?.toLowerCase();
    const discount = period?.discount ?? period?.interval_discount;

    if (unit === 'percent') {
        return cost * discount / 100;
    } else if (unit?.toUpperCase() === FIXED) {
        return discount * currencyRate;
    }

    return 0;
}
